import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Tabs, Tab, Container,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, IconButton, Select, MenuItem, Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { AuthContext } from '../..';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function LocationsMaster() {
  const { companyid, permissions, token } = useContext(AuthContext);
  const [tab, setTab] = useState(1);
  const [currentType, setCurrentType] = useState('Country');
  const [formData, setFormData] = useState({ value: '', country_id: '', state_id: '' });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editValue, setEditValue] = useState('');
  const [editId, setEditId] = useState(null);

  const [editicon, setEditicon] = useState(true);
  const [deleteiocn, setDeleteicon] = useState(true);


  useEffect(() => {
    if (companyid) {
      refreshData();
    }
  }, [companyid]);

  const handleTabChange = (event, value) => {
    setTab(value);
    if (value === 1) setCurrentType('Country');
    else if (value === 2) setCurrentType('State');
    else if (value === 3) setCurrentType('City');

    setFormData({ value: '', country_id: '', state_id: '' });
    setSelectedCountry('');
    setSelectedState('');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    if (!formData.value) {
      Swal.fire({ icon: 'error', title: 'Please enter a name.' });
      return;
    }
    if (tab === 2 && !selectedCountry) {
      Swal.fire({ icon: 'error', title: 'Please select a country.' });
      return;
    }
    if (tab === 3 && (!selectedCountry || !selectedState)) {
      Swal.fire({ icon: 'error', title: 'Please select country and state.' });
      return;
    }

    if (tab === 1) {
      axios.post(
        `${process.env.REACT_APP_API_LINKS}/locationsmaster/countries`,
        {
          companyid,
          name: formData.value
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'Country added', timer: 1500, showConfirmButton: false });
          setFormData(prev => ({ ...prev, value: '' }));
          refreshData();
        })
        .catch(err => Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data || 'Failed to add' }));
    }

    if (tab === 2) {
      axios.post(
        `${process.env.REACT_APP_API_LINKS}/locationsmaster/states`,
        {
          companyid,
          name: formData.value,
          country_id: selectedCountry
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'State added', timer: 1500, showConfirmButton: false });
          setFormData(prev => ({ ...prev, value: '' }));
          refreshData();
        })
        .catch(err => Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data || 'Failed to add' }));
    }

    if (tab === 3) {
      axios.post(
        `${process.env.REACT_APP_API_LINKS}/locationsmaster/cities`,
        {
          companyid,
          name: formData.value,
          country_id: selectedCountry,
          state_id: selectedState
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'City added', timer: 1500, showConfirmButton: false });
          setFormData(prev => ({ ...prev, value: '' }));
          refreshData();
        })
        .catch(err => Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data || 'Failed to add' }));
    }
  };

  const refreshData = () => {
    // if (!companyid) return;

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/countries`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    },)
      .then(res => setCountries(res.data))
      .catch(err => console.error('Failed to fetch countries:', err));

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/states`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    })
      .then(res => setStates(res.data))
      .catch(err => console.error('Failed to fetch states:', err));

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/cities`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    })
      .then(res => setCities(res.data))
      .catch(err => console.error('Failed to fetch cities:', err));
  };

  const getCurrentList = () => {
    if (tab === 1) return countries;
    if (tab === 2) return states;
    if (tab === 3) return cities;
    return [];
  };

  const handleEditClick = (item) => {
    setEditId(item.id);
    setEditValue(item.name);

    if (tab === 2) {
      setSelectedCountry(item.country_id);
    }
    if (tab === 3) {
      setSelectedCountry(item.country_id);
      setSelectedState(item.state_id);
    }

    setEditDialogOpen(true);
  };

  const handleUpdate = () => {
    if (!editValue) {
      Swal.fire({ icon: 'error', title: 'Please enter a name.' });
      return;
    }

    if (tab === 1) {
      axios.put(
        `${process.env.REACT_APP_API_LINKS}/locationsmaster/countries/${editId}`,
        { name: editValue },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'Country updated', timer: 1500, showConfirmButton: false });
          setEditDialogOpen(false);
          refreshData();
        })
        .catch(err => Swal.fire({ icon: 'error', title: 'Update failed', text: err.response?.data || '' }));
    }

    if (tab === 2) {
      if (!selectedCountry) {
        Swal.fire({ icon: 'error', title: 'Please select a country.' });
        return;
      }
      axios.put(
        `${process.env.REACT_APP_API_LINKS}/locationsmaster/states/${editId}`,
        {
          name: editValue,
          country_id: selectedCountry
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'State updated', timer: 1500, showConfirmButton: false });
          setEditDialogOpen(false);
          refreshData();
        })
        .catch(err => Swal.fire({ icon: 'error', title: 'Update failed', text: err.response?.data || '' }));
    }

    if (tab === 3) {
      if (!selectedCountry || !selectedState) {
        Swal.fire({ icon: 'error', title: 'Please select country and state.' });
        return;
      }
      axios.put(
        `${process.env.REACT_APP_API_LINKS}/locationsmaster/cities/${editId}`,
        {
          name: editValue,
          country_id: selectedCountry,
          state_id: selectedState
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'City updated', timer: 1500, showConfirmButton: false });
          setEditDialogOpen(false);
          refreshData();
        })
        .catch(err => Swal.fire({ icon: 'error', title: 'Update failed', text: err.response?.data || '' }));
    }
  };

  const handleDelete = (id) => {
    if (tab === 1) {
      axios.delete(`${process.env.REACT_APP_API_LINKS}/locationsmaster/countries/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'Country deleted', timer: 1500, showConfirmButton: false });
          refreshData();
        })
        .catch(() => Swal.fire({ icon: 'error', title: 'Delete failed' }));
    }

    if (tab === 2) {
      axios.delete(`${process.env.REACT_APP_API_LINKS}/locationsmaster/states/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'State deleted', timer: 1500, showConfirmButton: false });
          refreshData();
        })
        .catch(() => Swal.fire({ icon: 'error', title: 'Delete failed' }));
    }

    if (tab === 3) {
      axios.delete(`${process.env.REACT_APP_API_LINKS}/locationsmaster/cities/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then(() => {
          Swal.fire({ icon: 'success', title: 'City deleted', timer: 1500, showConfirmButton: false });
          refreshData();
        })
        .catch(() => Swal.fire({ icon: 'error', title: 'Delete failed' }));
    }
  };

  const permissionsaccess = () => {
    const mastersmodule = permissions.masters || {};
    setDeleteicon(mastersmodule.delete === true);
    setEditicon(mastersmodule.update === true);
  };
  useEffect(() => {
    if (permissions && permissions.masters) {
      permissionsaccess();
    }
  }, [permissions]);

  return (
    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3 },
      py: 3,
      backgroundColor: '#fff',
      minHeight: 'calc(100vh - 64px)',
      borderRadius: 2,
      boxShadow: { xs: 'none', sm: '0 0 8px rgba(0,0,0,0.1)' }
    }}>
      <Box>
        <Tabs value={tab} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
          <Tab label="Countries" value={1} />
          <Tab label="States" value={2} />
          <Tab label="Cities" value={3} />
        </Tabs>

        <Typography variant="h6" fontWeight={600} textAlign="center" my={2}>
          {currentType}
        </Typography>

        {permissions?.masters?.create &&
          <Box display="flex" gap={2} mb={2}>
            {(tab === 2 || tab === 3) && (
              <Select
                size="small"
                value={selectedCountry}
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  setSelectedState('');
                }}
                displayEmpty
                sx={{ minWidth: 150 }}
              >
                <MenuItem value="" disabled>Select Country</MenuItem>
                {countries.map((c) => (
                  <MenuItem key={c.id} value={c.id} sx={{ textTransform: 'capitalize' }}>{c.name}</MenuItem>
                ))}
              </Select>
            )}

            {tab === 3 && (
              <Select
                size="small"
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                displayEmpty
                sx={{ minWidth: 150 }}
              >
                <MenuItem value="" disabled>Select State</MenuItem>
                {states.filter(s => s.country_id === selectedCountry).map((s) => (
                  <MenuItem key={s.id} value={s.id} sx={{ textTransform: 'capitalize' }}>{s.name}</MenuItem>
                ))}
              </Select>
            )}

            <TextField
              size="small"
              label={`Add ${currentType}`}
              name="value"
              value={formData.value}
              onChange={handleInputChange}
            />
            <Button variant="contained" onClick={handleAdd}>Add</Button>
          </Box>}

        <TableContainer
          component={Paper}
          sx={{
            maxHeight: { xs: 300, sm: 400, md: 'calc(100vh - 220px)' },
            overflow: 'auto'
          }}
        >
          <Table stickyHeader size='small'>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>{currentType} Name</TableCell>
                {(tab === 2 || tab === 3) && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>Country</TableCell>}
                {tab === 3 && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>State</TableCell>}
                {(editicon || deleteiocn) && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {getCurrentList().map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell sx={{ textTransform: 'capitalize' }}>{item.name}</TableCell>
                  {(tab === 2 || tab === 3) && (
                    <TableCell sx={{ textTransform: 'capitalize' }}>
                      {countries.find(c => c.id === item.country_id)?.name || '-'}
                    </TableCell>
                  )}
                  {tab === 3 && (
                    <TableCell sx={{ textTransform: 'capitalize' }}>
                      {states.find(s => s.id === item.state_id)?.name || '-'}
                    </TableCell>
                  )}
                  {(editicon || deleteiocn) && <TableCell>
                    {editicon && <Tooltip title="Edit">
                      <IconButton onClick={() => handleEditClick(item)}>
                        <EditIcon sx={{ color: "#0b85c8", fontSize: '18px' }} />
                      </IconButton>
                    </Tooltip>}
                    {deleteiocn && <Tooltip title="Delete">
                      <IconButton onClick={() => handleDelete(item.id)}>
                        <DeleteIcon sx={{ color: "red", fontSize: '18px' }} />
                      </IconButton>
                    </Tooltip>}
                  </TableCell>}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)}>
          <DialogTitle>
            Edit {currentType}
            <IconButton
              aria-label="close"
              onClick={() => setEditDialogOpen(false)}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {(tab === 2 || tab === 3) && (
              <Select
                fullWidth
                value={selectedCountry}
                onChange={(e) => {
                  setSelectedCountry(e.target.value);
                  if (tab === 3) setSelectedState('');
                }}
                sx={{ mb: 2 }}
              >
                {countries.map((c) => (
                  <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
                ))}
              </Select>
            )}

            {tab === 3 && (
              <Select
                fullWidth
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
                sx={{ mb: 2 }}
              >
                {states.filter(s => s.country_id === selectedCountry).map((s) => (
                  <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                ))}
              </Select>
            )}

            <TextField
              fullWidth
              label={`Edit ${currentType}`}
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
            />
            <Box mt={2} textAlign="right">
              <Button variant="contained" onClick={handleUpdate}>Update</Button>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    </Container>
  );
};


